(()=>{
  function setup(root){
    if(root.dataset.bcReady)return;root.dataset.bcReady='true';
    root.querySelectorAll('[data-bc-jump]').forEach(link=>link.addEventListener('click',()=>{
      const target=document.getElementById(link.hash.slice(1));if(target&&target.tagName==='DETAILS')target.open=true;
    }));
    const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('.bc-compare-more').forEach(details=>{
      const summary=details.querySelector(':scope > summary');
      const body=details.querySelector(':scope > .bc-compare-more__body');
      if(!summary||!body||reducedMotion||typeof body.animate!=='function')return;
      summary.addEventListener('click',event=>{
        event.preventDefault();
        if(details.dataset.bcAnimating)return;
        const opening=!details.open;
        if(opening)details.open=true;
        details.dataset.bcAnimating='true';
        const fullHeight=body.scrollHeight;
        const animation=body.animate([
          {height:(opening?0:fullHeight)+'px',opacity:opening?0:1},
          {height:(opening?fullHeight:0)+'px',opacity:opening?1:0}
        ],{duration:300,easing:'cubic-bezier(.2,.7,.2,1)'});
        animation.onfinish=()=>{
          if(!opening)details.open=false;
          delete details.dataset.bcAnimating;
        };
        animation.oncancel=()=>{delete details.dataset.bcAnimating;};
      });
    });
    const bar=root.querySelector('[data-bc-mobile-buy]');
    const mainButton=root.querySelector('.product-form__add-button');
    const stickyButton=root.querySelector('[data-bc-buy]');
    if(!bar||!mainButton||!stickyButton)return;
    let inView=true;
    function sync(){
      const consent=document.querySelector('#shopify-pc__banner');
      const consentVisible=consent&&consent.getBoundingClientRect().height>0;
      const rect=mainButton.getBoundingClientRect();
      bar.hidden=inView||rect.top>0||consentVisible||window.innerWidth>740;
      stickyButton.disabled=mainButton.disabled;
      stickyButton.textContent=mainButton.disabled?mainButton.textContent.trim():'In winkelmandje';
      const price=root.querySelector('.price-list .price:not(.price--compare)');
      const dest=bar.querySelector('[data-bc-sticky-price]');
      if(price&&dest){const copy=price.cloneNode(true);copy.querySelectorAll('.visually-hidden').forEach(n=>n.remove());dest.textContent=copy.textContent.trim();}
    }
    stickyButton.addEventListener('click',()=>{if(!mainButton.disabled)mainButton.click();});
    new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;sync();}).observe(mainButton);
    const form=root.querySelector('form.product-form');
    if(form)new MutationObserver(sync).observe(form,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled']});
    window.addEventListener('resize',sync,{passive:true});window.addEventListener('scroll',sync,{passive:true});
    sync();
  }
  document.querySelectorAll('.bc-product').forEach(setup);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.bc-product').forEach(setup));
})();
